var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"viewBox":"0 0 24 24","aria-hidden":"true"},domProps:{"innerHTML":_vm._s(_vm.paths)}})
}
var staticRenderFns = []

export { render, staticRenderFns }